import _ from 'lodash';

const EXTERIOR = 'EXTERIOR';
const INTERIOR = 'INTERIOR';

const sortWithDefaultFirst = angles => {
  const defaultAngles = angles.filter(angle => angle.defaultAngle);
  const nonDefaultAngles = angles.filter(angle => !angle.defaultAngle);
  return defaultAngles.concat(nonDefaultAngles);
};

const createAngleMap = (options, type) => angle => {
  const {
    appResources,
    mmc,
    peg,
    rpos,
    interiorColor,
    exteriorColor,
    isConvertibleTopDown,
    breakpoint,
    year
  } = options;
  const { urls, cgiSize } = appResources;
  const isInterior = type === INTERIOR;

  const buildUrl = _.template(urls.cgiUrl);

  const context = {
    renderStandards: true,
    removeCat: isConvertibleTopDown ? 'CONV' : '',
    optionRPOs: rpos.join('_'),
    colorRPO: `${isInterior ? interiorColor : exteriorColor}_`,
    interior: isInterior ? 'interior' : '',
    mmc,
    peg,
    degree: angle.value,
    year
  };
  const isSmall = breakpoint === 'small';

  const urlContext = _.assign({}, context, {
    imageSize: isSmall ? cgiSize.small : cgiSize.large
  });
  const zoomUrlContext = _.assign({}, context, {
    imageSize: isSmall ? cgiSize.large : cgiSize.zoomLarge
  });

  return {
    id: angle.value,
    profile: angle.profileView,
    zoom: angle.displayZoom,
    url: buildUrl(urlContext),
    zoomUrl: buildUrl(zoomUrlContext)
  };
};

const getTokens = id => {
  const tokens = _.split(id, /_|-/);
  const uniqueTokens = _.uniq(tokens);
  return _.compact(uniqueTokens);
};

const buildMmcPegData = style => {
  const { codeForCGI, alternateId } = style.vehicleInfo;

  if (_.endsWith(codeForCGI, '-DRW')) {
    const tokens = codeForCGI.replace('-DRW', '').split('__');
    return {
      mmc: `${tokens[0]}D`,
      peg: `${tokens[0]}D__${tokens[1]}`
    };
  }

  const tokens = getTokens(alternateId || codeForCGI);
  return {
    mmc: tokens[0],
    peg: `${tokens[0]}__${tokens[1]}`
  };
};

export const normalize = (
  appResources,
  config,
  isConvertibleTopDown,
  breakpoint,
  year
) => {
  const { selections, style } = config;
  const { rpos, interiorColor, exteriorColor } = selections;
  const { mmc, peg } = buildMmcPegData(style);
  const { interiorAngles, exteriorAngles, year: defaultYear } = appResources;

  const options = {
    appResources,
    mmc,
    peg,
    rpos,
    interiorColor,
    exteriorColor,
    isConvertibleTopDown,
    breakpoint,
    year: year || defaultYear
  };

  const interior = sortWithDefaultFirst(interiorAngles).map(
    createAngleMap(options, INTERIOR)
  );
  const exterior = sortWithDefaultFirst(exteriorAngles).map(
    createAngleMap(options, EXTERIOR)
  );

  return {
    interior,
    exterior
  };
};

export const getProfileUrlByStyle = (
  style,
  appResources,
  isConvertibleTopDown,
  breakpoint,
  year
) => {
  const exteriorColor = style.vehicleInfo.defaultColor;
  const { mmc, peg } = buildMmcPegData(style);
  const rpos = [style.vehicleInfo.defaultTrim];
  const interiorColor = '';
  const { exteriorAngles, year: defaultYear } = appResources;

  const options = {
    appResources,
    mmc,
    peg,
    rpos,
    interiorColor,
    exteriorColor,
    isConvertibleTopDown,
    breakpoint,
    year: year || defaultYear
  };

  const exterior = sortWithDefaultFirst(exteriorAngles).map(
    createAngleMap(options, EXTERIOR)
  );

  const profile = _.find(exterior, 'profile') || _.first(exterior);

  return _.get(profile, 'url');
};
